// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'; // Initialize i18n
import App from './App';
import reportWebVitals from './reportWebVitals';
// serviceWorkerRegistration removed

const root = ReactDOM.createRoot(document.getElementById('root'));root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// serviceWorkerRegistration.register(); // Registration is now handled in AppUpdateNotification.js
reportWebVitals();